const TotalPriceIcon = () => {
  return (
    <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.5" width="32" height="32" rx="4" fill="#E9F2FF" />
      <path
        d="M15.9997 23.1673C19.6817 23.1673 22.6663 20.1827 22.6663 16.5007C22.6663 12.8187 19.6817 9.83398 15.9997 9.83398C12.3177 9.83398 9.33301 12.8187 9.33301 16.5007C9.33301 20.1827 12.3177 23.1673 15.9997 23.1673Z"
        stroke="#1062D0"
        strokeWidth="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18 14.168C17.5433 13.7113 16.7393 13.394 16 13.374M14 18.5013C14.4293 19.0746 15.2287 19.4013 16 19.4286M16 13.374C15.12 13.35 14.3333 13.748 14.3333 14.8346C14.3333 16.8346 18 15.8346 18 17.8346C18 18.9753 17.024 19.4653 16 19.4286M16 13.374V12.168M16 19.4286V20.8346"
        stroke="#1062D0"
        strokeWidth="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default TotalPriceIcon;
